import { RootState } from '@/store';

export const getExamAndTermsAndConditionsConsent = (state: RootState): boolean => state.journey.examAndTermsAndConditionsConsent;
export const getReturnToReviewFrom = (state: RootState): string | undefined => state.journey.returnToReviewFrom;
